<ul class="fastTrack-details-container">
  @if (fastTrack.name) {
    <li>
      <span class="light-fat" i18n="@@fastTrackdetails_name">Name:</span>
      <span [innerHTML]="fastTrack.name"></span>
    </li>
  }
  @if (fastTrack.description) {
    <li>
      <span class="light-fat" i18n="@@fastTrackdetails_description">Description:</span>
      <span [innerHTML]="fastTrack.description"></span>
    </li>
  }
  @if (fastTrack.importantInfo) {
    <li>
      <span class="light-fat" i18n="@@fastTrackdetails_info">Important Info:</span>
      <span [innerHTML]="fastTrack.importantInfo"></span>
    </li>
  }
  @if (fastTrack.extraInfo) {
    <li>
      <span class="light-fat" i18n="@@fastTrackdetails_info-extra">Extra Info:</span>
      <span class="fastTrack-info" [innerHTML]="fastTrack.extraInfo"></span>
    </li>
  }
</ul>
